import React from 'react';
import { PropTypes } from 'prop-types';
import { SelectDropdown } from '@origo_vl_banking/ibanking-react';
import { FormattedMessage } from 'react-intl';
import { Label } from '../../../components/grid/styled-components';

const loanTypes = [
  { key: '077', value: 'Lykillán' },
  { key: '057', value: 'Lykilsamningur' },
];

const LoanTypeDropdown = ({
  editable = true,
  handleSelect,
  selectedType,
  disabled = false,
  error = '',
}) => {
  if (editable) {
    return (
      <SelectDropdown
        label="CarConsolidationLoan.LoanType"
        name="loanType"
        headerHeight="34px"
        width="200px"
        data={loanTypes}
        onClicked={(item) => {
          handleSelect(item);
        }}
        displayValue={loanTypes.find(type => type.key === selectedType)?.value || selectedType}
        disabled={disabled}
        error={error}
        dataKey="key"
        dataValue="value"
      />
    );
  }

  return (
    <div>
      <Label style={{ marginBottom: 16, display: 'block' }}>
        <FormattedMessage id="CarConsolidationLoan.LoanType" />
      </Label>
      <span>{loanTypes.find(type => type.key === selectedType)?.value || selectedType}</span>
    </div>
  );
};

LoanTypeDropdown.propTypes = {
  selectedType: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  editable: PropTypes.bool,
  handleSelect: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default LoanTypeDropdown;
